import { defineMessages } from 'react-intl';

const messages = defineMessages({
  linkCopiedToClipboard: {
    id: 'BlendxCard.linkCopiedToClipboard',
    defaultMessage: 'Link copied to clipboard',
    description: 'A message shown in case when the user copies the link to the clipboard.',
  },
  free: {
    id: 'BlendxCard.free',
    defaultMessage: 'Free',
    description: 'A message shown in case when the user wants to view their organizations.',
  },
  resume: {
    id: 'BlendxCard.resume',
    defaultMessage: 'Resume',
    description: 'A message shown in case when the user wants to resume their course.',
  },
  edit: {
    id: 'BlendxCard.edit',
    defaultMessage: 'Edit Course',
    description: 'A message shown in case when the user wants to edit their course.',
  },
  viewLive: {
    id: 'BlendxCard.viewLive',
    defaultMessage: 'View Live',
    description: 'A message shown in case when the user wants to view their course live.',
  },
  noAccess: {
    id: 'BlendxCard.noAccess',
    defaultMessage: 'No Access',
    description: 'A message shown in case when the user does not have access to the course.',
  },
  estimatedTime: {
    id: 'BlendxCard.estimatedTime',
    defaultMessage: 'Estimated Time',
    description: 'A message shown in case when the user wants to view their course estimated time.',
  },
  startDate: {
    id: 'BlendxCard.startDate',
    defaultMessage: 'Starts on {startDate}',
    description: 'A message shown in case when the user wants to view their course start date.',
  },
  upcoming: {
    id: 'BlendxCard.upcoming',
    defaultMessage: 'Upcoming',
    description: 'A message shown in case when the user wants to view their course upcoming.',
  },
  ongoing: {
    id: 'BlendxCard.ongoing',
    defaultMessage: 'Ongoing',
    description: 'A message shown in case when the user wants to view their course ongoing.',
  },
});

export default messages;
